// extracted by mini-css-extract-plugin
export var notificationHost = "_ci-0";